"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("insurerContracts").controller("InsurerContractsCtrl", InsurerContractsCtrl).component("insurerContracts", {
    templateUrl: "app/pages/insurerContracts/insurerContracts.html",
    bindings: {
      resolve: "<?"
    },
    //transclude: true,
    controller: InsurerContractsCtrl
  });

  function InsurerContractsCtrl($rootScope, $scope, $timeout, $controller, AgGridService, InsurerContractsService, CustomersService) {
    var _this = this;

    var vm = this;
    vm.ctrlName = "InsurerContractsCtrl";

    vm.log = debug("pages:insurerContracts");

    $controller("ListBaseController", {
      vm: vm,
      $scope: $scope,
      service: InsurerContractsService,
      params: {
        editPage: "insurerContracts/insurerContract"
      }
    });

    vm.isAdmin = ["super-admin", "user-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isSuper = ["super-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.gridEvent = function (value) {
      if (value.type == "rowDoubleClicked") {
        vm.edit(value.data);
      }
    };

    vm.close = function () {
      console.log("$scope", $scope);
      if ($scope.$parent) {
        $scope.$parent.$close();
      }
    };

    vm.refresh = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        var insurer, customer, where, insurerContracts, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, insurerContract, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, type, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, doc;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (vm.isAdmin) {
                  _context.next = 3;
                  break;
                }

                $rootScope.$broadcast("auth_not_authorized");
                return _context.abrupt("return");

              case 3:
                if (!(params && (params.create || params.edit))) {
                  _context.next = 17;
                  break;
                }

                insurer = void 0;

                if (params.create) {
                  insurer = params.create;
                } else if (params.edit) {
                  insurer = params.edit;
                }

                _context.next = 8;
                return CustomersService.findById({
                  _id: $rootScope.$selectedCustomerId.replace("$", "")
                });

              case 8:
                customer = _context.sent;

                if (!(insurer.isDefaultContract === true && customer.defaultInsurerContract !== "$" + insurer._id)) {
                  _context.next = 14;
                  break;
                }

                _context.next = 12;
                return CustomersService.updateAttributesById($rootScope.$selectedCustomerId.replace("$", ""), {
                  defaultInsurerContract: "$" + insurer._id
                });

              case 12:
                _context.next = 17;
                break;

              case 14:
                if (!(insurer.isDefaultContract === false && customer.defaultInsurerContract === "$" + insurer._id)) {
                  _context.next = 17;
                  break;
                }

                _context.next = 17;
                return CustomersService.updateAttributesById($rootScope.$selectedCustomerId.replace("$", ""), {
                  defaultInsurerContract: null
                });

              case 17:

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                _context.prev = 18;

                vm.log("refresh insurerContracts", params);

                where = {};
                _context.next = 23;
                return InsurerContractsService.load(null, false, null, where);

              case 23:
                insurerContracts = _context.sent;


                vm.rawData = [];

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 28;
                _iterator = insurerContracts[Symbol.iterator]();

              case 30:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 90;
                  break;
                }

                insurerContract = _step.value;

                insurerContract.btEdit = {
                  text: '<i class="fa fa-edit"></i> Modifier',
                  color: "custom"
                };
                insurerContract.btDelete = {
                  text: '<i class="fa fa-trash"></i> Suppr.',
                  color: "custom-danger"
                };

                _context.prev = 34;

                if (!insurerContract.insurerEdiMandatoryDocs) {
                  _context.next = 80;
                  break;
                }

                insurerContract.insurerEdiMandatoryNameDocs = "";

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 40;
                _iterator2 = Object.keys(insurerContract.insurerEdiMandatoryDocs)[Symbol.iterator]();

              case 42:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 66;
                  break;
                }

                type = _step2.value;
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context.prev = 47;

                for (_iterator3 = Object.keys(insurerContract.insurerEdiMandatoryDocs[type])[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  doc = _step3.value;

                  insurerContract.insurerEdiMandatoryNameDocs += type + ":" + doc + ";";
                }
                _context.next = 55;
                break;

              case 51:
                _context.prev = 51;
                _context.t0 = _context["catch"](47);
                _didIteratorError3 = true;
                _iteratorError3 = _context.t0;

              case 55:
                _context.prev = 55;
                _context.prev = 56;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 58:
                _context.prev = 58;

                if (!_didIteratorError3) {
                  _context.next = 61;
                  break;
                }

                throw _iteratorError3;

              case 61:
                return _context.finish(58);

              case 62:
                return _context.finish(55);

              case 63:
                _iteratorNormalCompletion2 = true;
                _context.next = 42;
                break;

              case 66:
                _context.next = 72;
                break;

              case 68:
                _context.prev = 68;
                _context.t1 = _context["catch"](40);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 72:
                _context.prev = 72;
                _context.prev = 73;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 75:
                _context.prev = 75;

                if (!_didIteratorError2) {
                  _context.next = 78;
                  break;
                }

                throw _iteratorError2;

              case 78:
                return _context.finish(75);

              case 79:
                return _context.finish(72);

              case 80:

                vm.rawData.push(insurerContract);
                _context.next = 87;
                break;

              case 83:
                _context.prev = 83;
                _context.t2 = _context["catch"](34);

                console.error(_context.t2);

                Notiflix.Notify.failure("Une erreur est survenue sur l'object :" + insurerContract._id);

              case 87:
                _iteratorNormalCompletion = true;
                _context.next = 30;
                break;

              case 90:
                _context.next = 96;
                break;

              case 92:
                _context.prev = 92;
                _context.t3 = _context["catch"](28);
                _didIteratorError = true;
                _iteratorError = _context.t3;

              case 96:
                _context.prev = 96;
                _context.prev = 97;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 99:
                _context.prev = 99;

                if (!_didIteratorError) {
                  _context.next = 102;
                  break;
                }

                throw _iteratorError;

              case 102:
                return _context.finish(99);

              case 103:
                return _context.finish(96);

              case 104:

                Notiflix.Loading.remove();

                $timeout(function () {
                  _this.needToBeUpdate = true;
                });
                _context.next = 113;
                break;

              case 108:
                _context.prev = 108;
                _context.t4 = _context["catch"](18);

                Notiflix.Notify.failure("Une erreur est survenue au chargement des données");

                console.error(_context.t4);
                Notiflix.Loading.remove();

              case 113:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[18, 108], [28, 92, 96, 104], [34, 83], [40, 68, 72, 80], [47, 51, 55, 63], [56,, 58, 62], [73,, 75, 79], [97,, 99, 103]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    if (vm.isAdmin !== true) {
      vm.create = null;
      vm.edit = null;
    }

    vm.delete = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
        var deleteContract;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return swal({
                  title: "Voulez-vous supprimer le contrat " + row.name + " ?",

                  icon: "warning",
                  dangerMode: true,

                  buttons: ["Annuler", "Valider"]
                });

              case 2:
                deleteContract = _context2.sent;

                if (!deleteContract) {
                  _context2.next = 7;
                  break;
                }

                console.log("need to delete this contract", row);
                _context2.next = 7;
                return InsurerContractsService.deleteById(row._id).then(function () {
                  Notiflix.Notify.success("La suppression a réussi");
                  vm.refresh();
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    vm.columnDefs = [AgGridService.text("name", "Référence"), AgGridService.text("company", "Nom de l'assureur"), AgGridService.text("brokerCompany", "Nom du courtier"), AgGridService.date("subscriptionDate", "Souscription"), AgGridService.date("expirationDate", "Date de fin"), AgGridService.text("insurerEdiEmail", "Email de déclaration", true), AgGridService.text("insurerEdiMandatoryNameDocs", "Documents à transmettre", true)];

    var adminColumns = [];
    if (vm.isAdmin) {
      adminColumns.push(AgGridService.button("btEdit", "Modifier", vm.edit, this, {
        width: 90
      }));
    }
    if (vm.isSuper) {
      adminColumns.push(AgGridService.button("btDelete", "Suppr.", vm.delete, this, {
        width: 100,
        columnGroupShow: "open"
      }));
    }

    if (adminColumns && adminColumns.length > 0) {
      vm.columnDefs.unshift(AgGridService.group("Admin", adminColumns));
    }

    vm.refresh();
  }
})();